var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as VariantImageFactory from "../../classes/definitions/product/variantImage";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import VariantImagesList from '../../components/VariantImages/VariantImagesList/VariantImagesList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./VariantImagesReduxProps";
var VariantImages = /** @class */ (function (_super) {
    __extends(VariantImages, _super);
    function VariantImages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentProductId = '-1';
        _this.parentVariantId = '-1';
        _this.state = {
            data: [],
        };
        _this.getAllVariantImages = function () {
            _this.api.getVariantImages(_this.parentProductId, _this.parentVariantId)
                .then(function (response) {
                var values = VariantImageFactory.createVariantImages(response.data);
                _this.setState({ data: values });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим картинката.', _this.props.history);
            });
        };
        _this.toNewVariantImage = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentProductId + AppRoutes.variant.path + '/' + _this.parentVariantId + AppRoutes.variantImage.path);
        };
        _this.toEditVariantImage = function (selectedId) {
            if (selectedId !== '-1') {
                _this.props.history.push(AppRoutes.product.path + '/' + _this.parentProductId + AppRoutes.variant.path + '/' + _this.parentVariantId + AppRoutes.variantImage.path + ("/" + selectedId));
            }
        };
        _this.toParentVariant = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentProductId + AppRoutes.variant.path + '/' + _this.parentVariantId);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    VariantImages.prototype.componentDidMount = function () {
        this.parentProductId = _.get(this.props, 'match.params.id', '-1');
        this.parentVariantId = _.get(this.props, 'match.params.variantId', '-1');
        if (this.parentProductId !== '-1' && this.parentVariantId !== '-1') {
            this.getAllVariantImages();
        }
    };
    VariantImages.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0426\u0432\u0435\u0442\u043E\u0432\u0438 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewVariantImage, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430"),
                            React.createElement("a", { onClick: this.toParentVariant },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(VariantImagesList, { gridData: data, edit: this.toEditVariantImage, deleteItem: this.deleteItem, messages: this.messages }))))));
    };
    return VariantImages;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(VariantImages);



//////////////////
// WEBPACK FOOTER
// ./src/views/VariantImages/VariantImages.tsx
// module id = 500
// module chunks = 0